<template>
  <div class="list_subheader__container" v-bind:style="subheaderStyle">
    <div class="list_subheader__title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListSubheader',
  props: {
    title: String,
    subheaderStyle: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.list_subheader__container {
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  padding: 0 16px;
  background-color: #fafafa;
}
.list_subheader__title {
  font-family: sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: #262626;
}
</style>
